
















import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import {
  HsabExpenseCategory,
  HsabExpenseReimbursementResponse,
  HsabExpenseResponse,
} from "@/shared/types";
import HsabExpenseCardRowExpenseDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseDetail.vue";
import HsabExpenseCardRowPayee from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayee.vue";
import HsabExpenseCardRowDenial from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowDenial.vue";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import HsabExpenseCardRowContent from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowContent.vue";
import HsabExpenseCardRowExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseEvidence.vue";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import HsabExpenseDetailsModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    HsabExpenseEditModal,
    HsabExpenseDetailsModal,
    HsabExpenseCardRowExpenseEvidence,
    HsabExpenseCardRowContent,
    Pill,
    HsabExpenseCardRowPayee,
    HsabExpenseCardRowExpenseDetail,
    HsabExpenseCardRowDenial,
    Button,
    CurrencyAmount,
    HsabExpenseEvidence,
  }
})
export default class HsabExpenseCardRow extends Vue {

  themeStore = useThemeStore();

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  showDetailsModal = false;
  showEditModal = false;


  get expenseCategory (): HsabExpenseCategory {
    return this.expense.expenseCategory;
  }

  get reimbursement (): HsabExpenseReimbursementResponse {
    return this.expense.reimbursement;
  }


  handleCardRowClick (event: UIEvent) {
    if (this.expense.reimbursement) {
      this.showDetailsModal = true;
    } else {
      this.showEditModal = true;
    }
  }

  onCloseEvent () {
    this.showEditModal = false;
  }

  onCloseDetailsEvent () {
    this.showDetailsModal = false;
  }


}
